function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#FFF",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.033 9.998a8.967 8.967 0 1017.934 0c0-4.952-4.014-8.967-8.967-8.967S1.033 5.046 1.033 9.998zm13.858 0H4.293"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.962 13.667L4.293 9.998 7.962 6.33"
}));

function SvgBackOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _ref);
}

export default SvgBackOutline;